<template>
  <div :class="$style['container']">
    <div :class="$style['header']">
      <div :class="$style['header--content']">
        <Icon
          :name="'IconBell'"
          :size="18"
          :fill="'var(--color-primary-700)'"
        />
        <Paragraph1> {{ $t('notification.title') }}</Paragraph1>
      </div>
      <div
        :class="$style['header--content']"
        @click="markAllAsRead()"
      >
        <div :class="$style['button--content']">
          <IconShow :size="15" />
          <Paragraph6>{{ $t('notification.markAllAsRead') }}</Paragraph6>
        </div>
        <Icon
          :name="'IconX'"
          :size="20"
          :fill="'var(--color-primary-700)'"
          @click="close()"
        />
      </div>
    </div>

    <NotificationList
      v-if="lastNotifications && lastNotifications.length > 0"
      :class="$style['notification']"
      :is-in-panel="true"
      :need-close="false"
      :last-notifications="lastNotifications"
    />
    <div v-if="!lastNotifications || lastNotifications.length <= 0">
      <Paragraph1 :class="$style['no-notification']">
        {{ $t('NoNotification') }}
        <AssetsDefaultNoNotifications
          :width="200"
          :height="200"
        />
      </Paragraph1>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Icon } from '~/components-daisy/icons';
import { IconShow } from '~/components-daisy/icons';
import { markNotificationAsRead, useLastNotifications } from '~/composables/notifications/useNotifications';
import { notificationParams } from '~/app/types/notificationType';
import { Paragraph6 } from '~/components-daisy/typography';
import type { PFSNotification } from '~/app/types/notificationType';

const emits = defineEmits(['notification']);
const store = useFloristInfoStore();
const floristId = store.floristInfo.floristId;
const lastNotifications = ref<PFSNotification[]>(await useLastNotifications(floristId));
const lastNotificationsIdsArray: string[] = [];

onMounted(() => {
  lastNotifications.value.forEach((notification) => {
    if (!notification.isRead) {
      lastNotificationsIdsArray.push(notification.id);
    }
  });
});

const markAllAsRead = async () => {
  try {
    await markNotificationAsRead(floristId, lastNotificationsIdsArray);
    lastNotifications.value = await useLastNotifications(floristId);
    close();
  } catch (error) {
    console.error('error', error);
  }
};

const close = () => {
  notificationParams.displayedPanel = false;
  return emits('notification', notificationParams.displayedPanel);
};
</script>

<style lang="postcss" module>
.container {
  height: 100%;
  width: 100%;
}

.header {
  display: flex;
  justify-content: space-between;
  padding: var(--space-100) var(--space-150);
  background-color: var(--color-primary-300);
  align-items: center;
  &--content {
    display: flex;
    align-items: center;
    gap: var(--space-50);
  }
}

.notification {
  margin: var(--space-100);
}

.no-notification {
  display: flex;
  flex-direction: column;
  padding: var(--space-100);
  text-align: center;
  font-weight: 600;
  align-items: center;
  justify-content: center;
  height: fit-content;
  margin-top: var(--space-500);
}

.button {
  margin: var(--space-100);
  display: flex;
  justify-content: center;

  &--content {
    color: var(--color-primary-800);
    padding: 5px 10px;
    margin-inline: 10px;
    display: flex;
    justify-content: center;
    gap: 5px;
    align-items: center;
    transition: 250ms;

    &:hover {
      border-radius: 10px;
      background-color: var(--color-primary-400);
      transition: 250ms;
    }
  }
}
</style>
